import api from './api';

const unitsService = {
  // Buscar todas as unidades
  getAllUnits: async (params = {}) => {
    try {
      const response = await api.get('/units', { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar unidades:', error);
      throw error;
    }
  },

  // Buscar unidade por ID
  getUnitById: async (id) => {
    try {
      const response = await api.get(`/units/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar unidade:', error);
      throw error;
    }
  },

  // Criar nova unidade
  createUnit: async (unitData) => {
    try {
      const response = await api.post('/units', unitData);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar unidade:', error);
      throw error;
    }
  },

  // Atualizar unidade
  updateUnit: async (id, unitData) => {
    try {
      const response = await api.put(`/units/${id}`, unitData);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar unidade:', error);
      throw error;
    }
  },

  // Deletar unidade
  deleteUnit: async (id) => {
    try {
      const response = await api.delete(`/units/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao deletar unidade:', error);
      throw error;
    }
  }
};

export default unitsService;
